import { useMemo } from 'react';
import { aiExperienceApplicationMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';
import { TELL_AI, TELL_AGENT, USE_GENERAL_AI_KNOWLEDGE, USE_ROVO_ORGANISATION_KNOWLEDGE } from '../utils/constants';
import { useAIExperienceCommonDataContext } from './useAIExperienceCommonData';

/**
 * The use page knowledge toggle should only be visible when:
 * - there are agent conversation starters
 * - there is user input or ADF input but no general AI suggestions
 */
export var usePageKnowledgeToggle = function usePageKnowledgeToggle(_ref) {
  var hasInput = _ref.hasInput,
    suggestions = _ref.suggestions,
    agentVisible = _ref.agentVisible,
    nestedMenuSelected = _ref.nestedMenuSelected;
  var _useAIExperienceCommo = useAIExperienceCommonDataContext(),
    sendToAIExperienceMachine = _useAIExperienceCommo.sendToAIExperienceMachine,
    includeKnowledgeFromCurrentPage = _useAIExperienceCommo.includeKnowledgeFromCurrentPage;
  var pageKnowledgeIsVisible = useMemo(function () {
    var _suggestions$2;
    /**
     * Simplify the logic to not rely on the group heading copy and rely on constant values.
     */
    if (fg('ai-smart-button-team-25')) {
      var _suggestions$;
      var isGeneralAISuggestionRemaining = [TELL_AI, TELL_AGENT, USE_GENERAL_AI_KNOWLEDGE, USE_ROVO_ORGANISATION_KNOWLEDGE].includes((_suggestions$ = suggestions[0]) === null || _suggestions$ === void 0 ? void 0 : _suggestions$.value);
      return !!(agentVisible || isGeneralAISuggestionRemaining && !nestedMenuSelected);
    }
    var hasGeneralAiSuggestions = ((_suggestions$2 = suggestions[0]) === null || _suggestions$2 === void 0 ? void 0 : _suggestions$2.groupHeading) === aiExperienceApplicationMessages.atlassianIntelligenceGroupHeading.defaultMessage;
    return !!(agentVisible || hasInput && !hasGeneralAiSuggestions && !nestedMenuSelected);
  }, [agentVisible, nestedMenuSelected, hasInput, suggestions]);
  var pageKnowledgeProps = useMemo(function () {
    return {
      isEnabled: !!includeKnowledgeFromCurrentPage,
      isVisible: pageKnowledgeIsVisible,
      onToggle: function onToggle() {
        return sendToAIExperienceMachine({
          type: 'toggle use page knowledge'
        });
      }
    };
  }, [includeKnowledgeFromCurrentPage, pageKnowledgeIsVisible, sendToAIExperienceMachine]);
  return pageKnowledgeProps;
};